"use strict";
/**
 * Markets Converters
 * Conversion between different market data formats
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertEventToMarket = convertEventToMarket;
exports.kalshiEventToDisplayEvent = kalshiEventToDisplayEvent;
exports.sortDisplayEventsByDate = sortDisplayEventsByDate;
exports.convertEventMarketToMarket = convertEventMarketToMarket;
/**
 * Convert Event to Market format for display
 * LEGACY: Kept for backward compatibility
 */
function convertEventToMarket(event) {
    return {
        id: event.event_ticker,
        venue: "kalshi",
        title: event.title,
        subtitle: event.sub_title,
        category: event.category,
        status: "active",
        strike_price: 0.5,
        expiration_time: 0,
        last_price: 0.5,
        base_url: "",
        bid: 0.45,
        ask: 0.55,
    };
}
/**
 * Convert Kalshi Event to unified DisplayEvent format.
 * Derives scheduledDate from the earliest market expiration_time.
 */
function kalshiEventToDisplayEvent(event) {
    // Use the earliest nested-market expiration as the event's scheduled date
    let scheduledDate;
    if (event.markets && event.markets.length > 0) {
        let earliest = Infinity;
        for (const m of event.markets) {
            if (m.expiration_time) {
                const ts = new Date(m.expiration_time).getTime();
                if (ts < earliest) {
                    earliest = ts;
                }
            }
        }
        if (earliest < Infinity) {
            scheduledDate = new Date(earliest).toISOString();
        }
    }
    return {
        id: event.event_ticker,
        title: event.title,
        subtitle: event.sub_title,
        category: event.category,
        scheduledDate,
    };
}
/**
 * Sort display events by scheduledDate ascending (soonest first).
 * Events without a date are pushed to the end.
 */
function sortDisplayEventsByDate(events) {
    return events.sort((a, b) => {
        if (!a.scheduledDate && !b.scheduledDate)
            return 0;
        if (!a.scheduledDate)
            return 1;
        if (!b.scheduledDate)
            return -1;
        return (new Date(a.scheduledDate).getTime() -
            new Date(b.scheduledDate).getTime());
    });
}
/**
 * Convert MarketFromEvent to Market for state storage
 */
function convertEventMarketToMarket(market, eventData) {
    // Parse dollar strings to numbers
    const yesAsk = parseFloat(market.yes_ask_dollars || "0.50");
    const yesBid = parseFloat(market.yes_bid_dollars || "0.45");
    // Handle Kalshi markets where yes_sub_title and no_sub_title might be the same
    // If they're identical, only use yes_sub_title and set no_sub_title to undefined
    let yesSubtitle = market.yes_sub_title;
    let noSubtitle = market.no_sub_title;
    if (yesSubtitle && noSubtitle && yesSubtitle === noSubtitle) {
        // Both subtitles are the same - this means it's the same team/option
        // Keep the first one, clear the second so it defaults to "Opposing Team"
        noSubtitle = undefined;
    }
    return {
        id: market.ticker,
        venue: "kalshi",
        title: market.title,
        subtitle: market.subtitle,
        yesSubtitle: yesSubtitle,
        noSubtitle: noSubtitle,
        category: eventData?.category || "sports",
        status: market.status || "active",
        strike_price: 0.5,
        expiration_time: new Date(market.expiration_time).getTime(),
        last_price: parseFloat(market.last_price_dollars || "0.50"),
        base_url: "",
        bid: yesBid,
        ask: yesAsk,
    };
}
